import {
  INDEX_FAIL,
  INDEX_LOADING,
  INDEX_SUCCESS,
} from "../actions/returnType";
import { indexStateData } from "../constants/initalStateData";

export const initialReducer = (state = indexStateData, action) => {
  switch (action.type) {
    case INDEX_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        analytics:false
      };
    case INDEX_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        analytics:action.analytics,
      };
    }
    case INDEX_FAIL: {
      return {
        ...state,
        loading: false,
        error: true,
        success: false,
        message: action.message,
        accessToken: null,
      };
    }
    default:
      return state;
  }
};
